import { View, ViewModel } from "binder";
import { MultiSelectorBaseViewModel } from "src/common/reusableComponents/multiSelectorBase/multiSelectorBase-viewModel";
import { ServerConnection } from "src/server/serverConnection";

export class PersonnelMultiSelectorViewModel extends MultiSelectorBaseViewModel<personnel>{
    protected async loadData(): Promise<personnel[]> {
        let result = await ServerConnection.callServer('/Complex/PersonnelManipulationServices/GetAllPersonnelFullNames',{});
        return result.Personnel.map(x=>{
            let r = new personnel(this);
            r.id = x.Id;
            r.name = x.Name;
            r.lastName = x.LastName;
            r.id = x.Id;
            r.code = x.PersonnelCode;
            r.title = `${r.name} ${r.lastName} (${r.code})`;
            return r;
        });
    }

}

export class personnel extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
    }
    
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set lastName(v: string) { this._lastName = v; } public get lastName(): string { return this._lastName;} private _lastName: string;
    public set code(v: string) { this._code = v; } public get code(): string { return this._code;} private _code: string;
    public set title(v: string) { this._title = v; } public get title(): string { return this._title;} private _title: string;

}